import i18n from 'src/i18n'
// import { usePrimeVue } from 'primevue/config'
// import primevueLocale from 'src/locales/primevue/primevue-locale'
import api from '@api/index'
import DateService from 'src/services/DateService'
import { AvailableLanguage } from './AvailableLanguages'

export const changeLocale = async (locale: AvailableLanguage) => {
  if (locale && locale !== getLocale()) {
    // const primevue = usePrimeVue()
    // primevue.config.locale = primevueLocale[locale]

    i18n.locale.value = locale
    DateService.setLocale(locale)
    localStorage.setItem('locale', locale)
    await api.language.changeUserLanguage(locale)
  }
}

export const getLocale = (): AvailableLanguage => {
  return (
    (localStorage.getItem('locale') as AvailableLanguage) || i18n.locale.value
  )
}

export const translateNumberToLocaleFormat = (number: number): string => {
  return Number(number).toLocaleString(getLocale())
}
